var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDislike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 92.87,
    height: 92.87,
    viewBox: "0 0 92.87 92.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_121",
    x: 0,
    y: 0,
    width: 92.87,
    height: 92.87,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_323_2",
    "data-name": "Component 323 \\u2013 2",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1598",
    "data-name": "Group 1598",
    transform: "translate(-767 -773.9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 758, 767.9)",
    filter: "url(#Path_121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121-2",
    "data-name": "Path 121",
    d: "M76.37,38.935A37.435,37.435,0,1,1,38.935,1.5,37.435,37.435,0,0,1,76.37,38.935",
    transform: "translate(7.5 4.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128",
    transform: "translate(827.999 838.614) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M33.049,45.63c-1.51.245-3,.413-4.449.742a53.448,53.448,0,0,0-5.349,1.456,19.447,19.447,0,0,1-5.842,1.01c-2.509.055-5.023-.077-7.535-.079A4.407,4.407,0,0,1,5.5,44.185a2.261,2.261,0,0,0-.488-1.938c-.323-.325-.713-.591-1-.942a5.223,5.223,0,0,1-1.052-4.636,2.407,2.407,0,0,0-.615-2.257,5.2,5.2,0,0,1-1.054-5.83A1.478,1.478,0,0,0,1.1,26.909a4.827,4.827,0,0,1-1.02-3.847,3.243,3.243,0,0,1,2.962-2.726c2.057-.116,4.121-.085,6.182-.142,1.891-.053,3.782-.136,5.673-.215a3.452,3.452,0,0,0,.717-.129c1.2-.316,1.63-1.006,1.166-2.181-.528-1.336-1.186-2.622-1.806-3.921A18.606,18.606,0,0,1,13.1,8.132a8.3,8.3,0,0,1,1.49-6.491A5.366,5.366,0,0,1,16.058.358a1.813,1.813,0,0,1,2.906,1.216c.265,1.048.4,2.128.586,3.2A22.377,22.377,0,0,0,21.315,11a6.464,6.464,0,0,0,2.155,2.3A18.232,18.232,0,0,1,27.8,18.42q2.047,3.155,4.083,6.317a.71.71,0,0,0,.136.179A3.31,3.31,0,0,1,33.092,27.9c-.048,5.772-.021,11.546-.022,17.318,0,.146-.015.291-.022.413",
    fill: "#b90101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M6.023,0h5.2c.7,0,.806.1.807.779q0,10.492,0,20.982c0,.756-.116.867-.89.867H.841C.158,22.63,0,22.478,0,21.8c.012-1.744.048-3.489.046-5.234Q.036,8.969,0,1.373c0-.2,0-.392,0-.589C.012.139.14.006.776,0Q3.4,0,6.023,0Z",
    transform: "translate(35.368 24.531)",
    fill: "#b90101"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.c04437fdc7232c112dee03d08516b59e.svg";
export { ForwardRef as ReactComponent };